<template>
	<v-dialog
			v-model="showDialog_"
			persistent
			width="1050px">
		<template v-slot:activator="{ on }">
			<v-btn v-on="on">
				<v-row no-gutters align="end">
					<v-col class="center">
						<v-icon>build</v-icon>
					</v-col>
					<v-col class="ml-2 center">
						<span class="button_">PAGE</span>
					</v-col>
				</v-row>
			</v-btn>
		</template>
		<v-card class="customVCard">
			<v-card-title>
				<v-row class="pt-2" justify="center">
					<v-col cols="auto">
						PAGE BUILDER
					</v-col>
				</v-row>
			</v-card-title>
			<v-card-text>
				<!-- tab -->
				<v-row class="px-2" align="center">
					<v-col>
						<v-tabs	v-model="selectedTab_"
								color="success">
							<template v-for="key in tabs_">
								<v-tab :key="key" v-text="key" />
							</template>
						</v-tabs>
					</v-col>
				</v-row>
				<!-- item -->
				<v-row class="px-2" align="center">
					<!-- combobox -->
					<v-col>
						<!-- inits -->
						<template v-if="selectedTab_ == 0">
							<v-select
									v-model="selectedItem_"
									color="success"
									:items="items_[selectedTab_]" />
						</template>
						<!-- contents -->
						<template v-else-if="(selectedTab_ == 1)">
							<v-combobox
									v-model="selectedItem_"
									color="success"
									:items="items_[selectedTab_]" />
						</template>
					</v-col>
					<!-- build button -->
					<v-col cols="auto">
						<v-btn	color="success"
								:disabled="!selectedItem_"
								icon
								small
								@click="$_bldrPgDlg_setParams()">
							<v-icon>build</v-icon>
						</v-btn>
					</v-col>
					<!-- code button -->
					<v-col cols="auto">
						<v-dialog
								v-model="showDialogJSON_"
								persistent
								width="750px">
							<template v-slot:activator="{ on }">
								<v-btn	color="success"
										:disabled="!selectedItem_"
										icon
										@click="$_bldrPgDlg_openTextarea(on)">
									<v-icon>code</v-icon>
								</v-btn>
							</template>
							<v-card class="customVCard">
								<v-card-text>
									<v-textarea v-model="paramsJSON_" />
								</v-card-text>
								<v-card-actions>
									<v-row dense justify="center">
										<v-col cols="auto">
											<v-btn	color="success"
													@click="$_bldrPgDlg_updateParamsWithJSON()">
												Set
											</v-btn>
										</v-col>
										<v-col cols="auto">
											<v-btn	color="secondary"
													@click="$_bldrPgDlg_closeTextarea()">
												Cancel
											</v-btn>
										</v-col>
									</v-row>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</v-col>
				</v-row>
				<!-- params -->
				<template v-for="(paramVal, paramKey) in sortObject(paramsLeft_)">
					<v-row class="px-2" :key="paramKey">
						<v-col cols="3">
							<v-alert
									class="customVAlert"
									color="success"
									outlined>
								<span	class="caption dev_"
										v-text="paramKey" />
							</v-alert>
						</v-col>
						<v-col cols="3">
							<v-alert
									class="customVAlert"
									color="success"
									outlined>
								<pre	class="prettyprint caption pretty_ dev_"
										v-text="paramVal" />
							</v-alert>
						</v-col>
						<v-col class="px-0" cols="auto">
							<v-btn	color="success"
									icon
									@click="$_bldrPgDlg_updateParams(paramKey)">
								<v-icon>keyboard_arrow_left</v-icon>
							</v-btn>
						</v-col>
						<v-col>
							<v-alert
									class="customVAlert pa-3"
									color="success"
									outlined>
								<template v-if="isBoolean(paramsLeft_[paramKey])">
									<v-switch
											class="ma-1 label_"
											v-model="paramsRight_[paramKey]"
											color="success"
											dense
											hide-details />
								</template>
								<template v-else>
									<v-textarea
											class="ma-1 prettyprint caption pretty_"
											v-model="paramsRight_[paramKey]"
											auto-grow
											color="success"
											dense
											hide-details
											rows="1" />
								</template>
							</v-alert>
						</v-col>
						<template v-if="paramKey == 'text'">
							<v-col class="pl-0 center" cols="auto">
								<v-btn	color="success"
										icon
										@click="openLink({ url: 'https://colab.research.google.com/drive/11-Ks7-epfw_oIOaFKDpsCT1BUze-yMoQ' })">
									<v-icon>developer_mode</v-icon>
								</v-btn>
							</v-col>
						</template>
					</v-row>
				</template>
			</v-card-text>
			<v-card-actions>
				<!-- buttons -->
				<v-row class="px-2 pb-3" justify="center" dense>
					<v-col cols="auto">
						<v-btn	color="success"
								:disabled="!paramsUpdated_ || !selectedItem_"
								large
								@click="$_bldrPgDlg_save(false)">
							<template v-if="isFalse(onProgress_)">
								Save
							</template>
							<template v-else>
								<progress-circular />
							</template>
						</v-btn>
					</v-col>
					<v-col cols="auto">
						<v-btn	color="success"
								:disabled="!paramsUpdated_ || !selectedItem_"
								large
								@click="$_bldrPgDlg_save(true)">
							<template v-if="isFalse(onProgress_)">
								Save & Reload
							</template>
							<template v-else>
								<progress-circular />
							</template>
						</v-btn>
					</v-col>
					<v-col cols="auto">
						<v-btn	color="secondary"
								large
								@click="$_bldrPgDlg_close()">
							Close
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'BuilderPageDialog',
		data() {
			return {
				showDialog_: false,
				showDialogJSON_: false,
				// tab
				tabs_: [ 'inits', 'contents' ],
				selectedTab_: 0,
				// item
				items_: [
					// inits
					[ 'info', 'lang', 'link', 'style' ],
					// contents
					[]
				],
				selectedItem_: null,
				// state
				state_: [
					// inits state
					{
						info: {},
						lang: {},
						link: {},
						style: {}
					},
					// contents state
					{ new: {} }
				],
				// params
				paramsLeft_: {},
				paramsRight_: {},
				paramsJSON_: null,
				paramsUpdated_: false,
				// save button
				onProgress_: false
			}
		},
		computed: {
			// state
			$_bldrPgDlg_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_bldrPgDlg_statePageName() {
				const self_ = this;
				return self_.getPageState('name')
			},
			$_bldrPgDlg_statePageType() {
				const self_ = this;
				return self_.getPageState('type')
			}
		},
		created() {
			const self_ = this;

			self_.$_bldrPgDlg_reset()
		},
		methods: {
			$_bldrPgDlg_setInitsState() {
				const self_ = this;
				
				const initsPage_ = self_.getPageInits(self_.$_bldrPgDlg_statePageName)
				const initsType_ = self_.getPageInits(self_.$_bldrPgDlg_statePageType + '_')
				const initsDefault_ = self_.getPageInits('default_')

				let inits_ = {}
				if(!self_.isEmpty(initsPage_)) { inits_ = initsPage_ }
				else if(!self_.isEmpty(initsType_)) { inits_ = initsType_ }
				else { inits_ = initsDefault_ }
				// set state
				self_.state_[0] = inits_;
			},
			$_bldrPgDlg_setContentsState() {
				const self_ = this;

				const contentsPage_ = self_.getPageContents(self_.$_bldrPgDlg_statePageName)
				const contentsType_ = self_.getPageContents(self_.$_bldrPgDlg_statePageType + '_')
				const contentsDefault_ = self_.getPageContents('default_')

				let contents_ = {}
				// new
				if(!self_.isEmpty(contentsType_)) { contents_.new = contentsType_.new }
				else { contents_.new = contentsDefault_.new }
				// existing
				if(!self_.isEmpty(contentsPage_)) { contents_ = self_.sortObject(contentsPage_, 'order') }
				// set items & state
				self_.items_[1] = Object.keys(contents_)
				self_.state_[1] = contents_;
			},
			$_bldrPgDlg_setParams() {
				const self_ = this;

				self_.paramsLeft_ = self_.parseObject(self_.state_[self_.selectedTab_][self_.selectedItem_])
				self_.paramsRight_ = {}
				self_.paramsUpdated_ = false;

				Object.keys(self_.paramsLeft_).forEach(key => {
					// object
					if(self_.isObject(self_.paramsLeft_[key]) || JSON.stringify(self_.paramsLeft_[key]) == '{}') {
						self_.paramsRight_[key] = JSON.stringify(self_.paramsLeft_[key])
					// boolean
					} else if(self_.isBoolean(self_.paramsLeft_[key])) {
						if(self_.paramsLeft_[key]) { self_.paramsRight_[key] = 1 }
						else { self_.paramsRight_[key] = 0 }
					// null
					} else if(self_.isFalse(self_.paramsLeft_[key])) {
						self_.paramsRight_[key] = 'NULL';
					// text & number
					} else {
						self_.paramsRight_[key] = self_.paramsLeft_[key]
					}
				})
			},
			$_bldrPgDlg_updateParams(key) {
				const self_ = this;

				// inits & contents
				if(self_.selectedTab_ == 0 || self_.selectedTab_ == 1) {
					// object
					if(self_.isObject(self_.paramsLeft_[key]) || JSON.stringify(self_.paramsLeft_[key]) == '{}') {
						self_.paramsLeft_[key] = JSON.parse(self_.paramsRight_[key])
					// boolean
					} else if(self_.isBoolean(self_.paramsLeft_[key])) {
						if(self_.paramsRight_[key] == 0) { self_.paramsLeft_[key] = false }
						else { self_.paramsLeft_[key] = true }
					// null
					} else if(self_.paramsRight_[key].toLowerCase() == 'null') {
						self_.paramsLeft_[key] = null;
					// text & number
					} else {
						if(self_.isNumber(self_.paramsLeft_[key])) {
							self_.paramsLeft_[key] = Number(self_.paramsRight_[key])
						} else {
							self_.paramsLeft_[key] = self_.paramsRight_[key]
						}
					}
				}
				// langs & styles
				else if(self_.selectedTab_ == 2 || self_.selectedTab_ == 3) {
					const param_ = self_.paramsRight_[key]
					// object
					if(param_.substr(0, 1) == '{') {
						self_.paramsLeft_[key] = JSON.parse(param_)
					}
					// string
					else {
						self_.paramsLeft_[key] = param_;
					}
				}

				self_.paramsUpdated_ = true;
			},
			$_bldrPgDlg_openTextarea() {
				const self_ = this;
				self_.paramsJSON_ = JSON.stringify(self_.paramsLeft_)
				self_.showDialogJSON_ = true;
			},
			$_bldrPgDlg_closeTextarea() {
				const self_ = this;
				self_.showDialogJSON_ = false;
			},
			$_bldrPgDlg_updateParamsWithJSON() {
				const self_ = this;

				self_.paramsLeft_ = JSON.parse(self_.paramsJSON_)
				self_.paramsUpdated_ = true;	

				self_.showDialogJSON_ = false;
			},
			$_bldrPgDlg_save(reload) {
				const self_ = this;

				self_.onProgress_ = true;

				const type_ = self_.tabs_[self_.selectedTab_];

				let key_ = null;
				if(self_.selectedItem_ == 'new') { key_ = self_.getChanceDocumentKey() }
				else { key_ = self_.selectedItem_; }

				Promise.resolve().then(() => {
					return self_.setFirestoreSubDocument(type_, 'page', self_.$_bldrPgDlg_statePageName, key_, self_.paramsLeft_)						
				}).then(() => {
					if(reload) {
						self_.openLink({ method: { name: 'reload' }})
					} else {
						self_.$_bldrPgDlg_reset()
					}
				}).catch(error => {
					console.log(error)
				})
			},
			$_bldrPgDlg_reset() {
				const self_ = this;

				self_.paramsLeft_ = {}
				self_.paramsRight_ = {}
				self_.paramsJSON_ = null;
				self_.paramsUpdated_ = false;

				self_.onProgress_ = false;
				self_.showDialogJSON_ = false;

				self_.$_bldrPgDlg_setInitsState()
				self_.$_bldrPgDlg_setContentsState()
			},
			$_bldrPgDlg_close() {
				const self_ = this;

				self_.showDialog_ = false;

				self_.selectedCategory_ = null;
				self_.selectedTab_ = 0;
				self_.selectedItem_ = null;

				self_.$_bldrPgDlg_reset()
			}
		}
	}
</script>

<style scoped>
	.button_ {
		font-size: xx-small !important;
	}
	.title_ {
		color: #ff5252;
	}
	.radio_ {
		margin-top: 20px;
		margin-bottom: 0 !important;
	}
	.mergin_ {
		margin-top: 0;
		margin-bottom: 0;
	}
	.pretty_ {
		border: none;
	}
	.debug_ {
		color: #ff5252;
	}
	.dev_ {
		color: #4caf50;
	}
</style>
